<template>
  <a-layout class="terms-and-conditions">
    <TitleBreadcrumb />
    <div class="content-base container" v-html="termsAndConditions"></div>
  </a-layout>
</template>
<script>
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "../../utils/utils";
import labels from "@/utils/labels";
import { mapGetters } from "vuex";
export default {
  components: { TitleBreadcrumb },
  name: "TermsAndConditions",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.termsAndConditions.title),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.termsAndConditions.title,
      },
    ],
  },
  computed: {
    ...mapGetters({
      termsAndConditions: "systemConfig/getTermsAndConditions",
      loading: "systemConfig/getIsLoading",
    }),
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.terms-and-conditions {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .content-base {
    padding-top: 60px;
    padding-bottom: 0;
    @media screen and (max-width: $screen-mobile) {
      max-width: 100% !important;
    }
  }
  *:not(a) {
    color: var(--text) !important;
  }
  a {
    color: var(--link) !important;
    text-decoration: underline;
    font-weight: 500;
  }
}
</style>
